import axios from 'axios';
import React, { useMemo } from 'react';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

const CustomSunEditor = ({ value, onChange, height = '400px', onGetInstance }) => {
  const sortedFontOptions = useMemo(() => [
    "Logical",
    "Salesforce Sans",
    "Garamond",
    "Sans-Serif",
    "Serif",
    "Times New Roman",
    "Helvetica"
  ].sort(), []);

  const onImageUploadBefore = (file, info, uploadHandler) => {
    const fd = new FormData();
    fd.append('product_link', file[0]);

    axios.post(
      `${process.env.REACT_APP_API_URL}/upload/image`,
      fd
    ).then((res) => {
      const response = {
        "result": [
          {
            "url": `${process.env.REACT_APP_API_URL}${res?.data}`,
            "name": res?.data
          }
        ]
      };
      return uploadHandler(response);
    });
  };

  const editorOptions = useMemo(() => ({
    buttonList: [
      ["undo", "redo"],
      ["font", "fontSize"],
      ['paragraphStyle', 'blockquote'],
      ["bold", "underline", "italic", "strike", "subscript", "superscript"],
      ["fontColor", "hiliteColor"],
      ["align", "list", "lineHeight"],
      ["outdent", "indent"],
      ["table", "horizontalRule", "link", "image", "video"],
      ["fullScreen", "showBlocks", "codeView"],
      ["preview", "print"],
      ["removeFormat"],
    ],
    defaultTag: "div",
    minHeight: "300px",
    showPathLabel: false,
    font: sortedFontOptions,
    // Chỉ cho phép một số thuộc tính cơ bản, loại bỏ inline style phức tạp từ Tailwind khi paste
    pasteTagsWhitelist: 'p|br|h1|h2|h3|h4|h5|h6|strong|em|b|i|u|s|ul|ol|li|table|thead|tbody|tr|th|td|a|img|blockquote|pre|code|span|div',
    // Không giữ lại tất cả style attributes (nguyên nhân của nội dung bị phình to)
    // attributesWhitelist đã bị xóa để tránh Tailwind CSS inline styles
  }), [sortedFontOptions]);


  const editorRef = React.useRef();
  // Flag to prevent onChange loop when setContents is called programmatically
  const isSettingContent = React.useRef(false);

  const getSunEditorInstance = (instance) => {
    editorRef.current = instance;
    // Expose instance to parent component via onGetInstance prop
    if (onGetInstance) onGetInstance(instance);
  }

  // Effect to handle external value changes (initial load) without causing feedback loops
  React.useEffect(() => {
    if (editorRef.current && value !== undefined && value !== editorRef.current.getContents()) {
      isSettingContent.current = true;
      editorRef.current.setContents(value || "");
      // Use longer timeout to safely cover SunEditor's async onChange dispatch
      setTimeout(() => {
        isSettingContent.current = false;
      }, 500);
    }
  }, [value]);

  return (
    <SunEditor
      height={height}
      defaultValue={value}
      getSunEditorInstance={getSunEditorInstance}
      onChange={(content) => {
        // Ignore onChange events triggered by programmatic setContents
        if (isSettingContent.current) return;
        if (onChange) onChange(content);
      }}
      onImageUploadBefore={onImageUploadBefore}
      setOptions={editorOptions}
    />
  );
};

export default CustomSunEditor;
